'use strict';

define('lib/helpers/replaceDisclaimer',['Handlebars'], function (Handlebars) {
  // BAT-3173, Vehicle Benefits. see vehicles/priusprime/
  Handlebars.registerHelper('replaceDisclaimer', function (key, options) {
    var string = options.fn(this);
    var fixedKey = '';
    var className = 'js-disclaimer-trigger';

    // NEED TO FIX THE KEY(s) COMING FROM TCOM THAT DON'T MATCH OUR CACHE MAP.
    switch (key) {
      case '[prime_incentives]': // tcom passes '[prime_incentives]. while we have 'incentives' in our cache map.
        fixedKey = '[incentives]';
        break;
      case '[prime_calculations_2018]':
        fixedKey = '[prime_calculations]';
        break;
      case '[msrp]':
        className = 'js-disclaimer-msrp';
        break;
      default:
        fixedKey = key;
        break;
    }

    fixedKey = fixedKey.replace('[', '').replace(']', '');
    // THIS GETS UPDATED LATER IN disclaimer service : updateBenefitsDisclaimers
    var disclaimerString = '<sup class="color-red footnote"><a class="' + className + '" href="#" data-keyid="' + fixedKey + '"></a></sup>';
    var replaced = '';
    // console.log('-------\n  INDEX OF ',  string.indexOf('['));
    if ( string.indexOf('[') === -1) {
      // BUST OUT HERE CAUSE THERE'S NOTHING TO REPLACE.
      replaced = string.replace(key, disclaimerString);
      return replaced;
    }

    // NEED TO REMOVE SOME SPACE AND REPLACE HERE:
    var io = string.indexOf('[') - 1; // remove last space before [prime_blah]
    var wholeString = string;
    string = wholeString.substr(0, io) + '' + wholeString.substr(io + 1);
    replaced = string.replace(key, disclaimerString);
    return replaced;
  });
});

